module.exports = __webpack_public_path__ + "img/0015.efccf8e5.jpg";